// extracted by mini-css-extract-plugin
export var iconEllipsis = "pagination-module--icon-ellipsis--5e151";
export var pageButton = "pagination-module--page-button--5fd45";
export var pageButtonActive = "pagination-module--page-button-active--2855c";
export var pageSize = "pagination-module--page-size--a4fe9";
export var paginationContainer = "pagination-module--pagination-container--6a751";
export var paginationNumbers = "pagination-module--pagination-numbers--76112";
export var paginationPages = "pagination-module--pagination-pages--897bf";
export var paginationSelector = "pagination-module--pagination-selector--a9161";
export var paginationTotal = "pagination-module--pagination-total--0e6d5";